const Link = {
	init: () => {
		let elements = document.querySelectorAll('[data-href]');
		if(!elements) return;

		elements.forEach((elem) => {
			elem.addEventListener('click', (e) => {
				const event = new CustomEvent('mousedown', {
					detail: {
						clickedTarget: e.target,
					}
				});

				elem.dispatchEvent(event);
			});

			elem.addEventListener('mousedown', (e) => {
				if(e.target.getAttribute('data-href-stop') || e.detail.clickedTarget.getAttribute('data-href-stop')) return;

				const elemTarget = elem.getAttribute('data-target');
				const elemHref = elem.getAttribute('data-href');

				if(e.which === 3) return;

				if(e.which === 2) {
					window.open(elemHref, '_blank');
					return;
				}

				if(elemTarget == null || typeof elemTarget === undefined) {
					location.href = elemHref;
				} else {
					window.open(elemHref, '_blank');
				}
			});
		});
	}
}

export default Link;
